import { useEffect } from "react";

/**
 * Injects the Zoho SalesIQ live chat widget.
 *
 * @param enabled - When false the widget is not injected, and an already
 * injected one is torn down. Clients can turn it off via the `disableChat` flag
 * in their theme file so they can run their own chat plugin instead.
 */
export const useLiveChat = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    // Don't inject if already present
    if (document.getElementById("zsiqscript")) return;

    const bootstrapScript = document.createElement("script");
    bootstrapScript.setAttribute("type", "text/javascript");
    bootstrapScript.setAttribute("id", "scriptid");
    bootstrapScript.text = `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`;

    const widgetScript = document.createElement("script");
    widgetScript.setAttribute("id", "zsiqscript");
    widgetScript.src =
      "https://salesiq.zohopublic.eu/widget?wc=siq7b375e6e29e57c287adce25599f9910046b93a0be234a7db00af173d9448be4b975d7e2ebba20b9be092d1276f8790a6";
    widgetScript.defer = true;

    document.body.appendChild(bootstrapScript);
    document.body.appendChild(widgetScript);

    return () => {
      document.getElementById("scriptid")?.remove();
      document.getElementById("zsiqscript")?.remove();
    };
  }, [enabled]);
};
